/**
 * Campaign types that are gated behind a paid plan in the template library.
 *
 * This is the UX half only — the authoritative gate is backend enforcement on
 * campaign creation. Keep the two in step: this list exists so a free merchant
 * never reaches a create call that is going to be rejected.
 *
 * @fileoverview Free-plan lock rules for template cards
 */

export const LOCKED_CAMPAIGN_TYPES = Object.freeze(['socialProof']);

/**
 * @param {string} [campaignType] - `campaign_type` from the template record
 * @param {boolean} [isFreePlan] - Whether locks apply to this shop right now.
 *   Callers MUST pass `false` until the shop record has actually loaded — see
 *   TemplateLibrary.jsx's `locksReady`.
 * @returns {boolean} plain boolean, safe as a memo-compared prop
 */
export function isTemplateLocked(campaignType, isFreePlan) {
  return !!isFreePlan && LOCKED_CAMPAIGN_TYPES.includes(campaignType);
}
